import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

type Status = 'green' | 'red';

interface StatusIndicatorProps {
  status: Status;
}

const GlowDot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'status',
})<{ status: Status }>(({ status }) => ({
  width: 12,
  height: 12,
  borderRadius: '50%',
  backgroundColor: `var(--color-${status})`,
  boxShadow: `0 0 6px var(--color-${status})`,
}));

const StatusIndicator: React.FC<StatusIndicatorProps> = ({ status }) => {
  return <GlowDot status={status} />;
};

export default StatusIndicator;